import React from 'react';
import PropTypes from 'prop-types';

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';

const AnalystDetailsTable = ({ data }) => {
  const defaultSorted = [
    {
      dataField: 'name',
      order: 'asc'
    }
  ];

  const headerFormatter = (
    column,
    colIndex,
    { sortElement, filterElement }
  ) => {
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {column.text}
        <div style={{ color: '#0c8ed7' }}>
          {sortElement ? sortElement : null}
        </div>
      </div>
    );
  };

  const allowanceFormatter = (cell, row) => {
    if (cell > 0) {
      return <span style={{ color: '#37a442' }}>+{cell}</span>;
    }

    if (cell < 0) {
      return <span style={{ color: '#e16363' }}>{cell}</span>;
    }

    return <span>{cell}</span>;
  };

  const bandWithFormatter = (cell, row) => {
    return (
      <div>
        <progress value={cell.actual} max={cell.total}></progress>
        <span style={{ margin: '10px', color: '#6a7088' }}>
          {cell.actual} / {cell.total}
        </span>
      </div>
    );
  };

  const sortBandwith = (a, b, order, dataField) => {
    const percentageA = a.actual / a.total;
    const percentageB = b.actual / b.total;

    if (order === 'asc') {
      return percentageA - percentageB;
    }

    return percentageB - percentageA;
  };

  const columns = [
    {
      dataField: 'name',
      text: 'Analyst',
      sort: true,
      headerFormatter: headerFormatter
    },
    {
      dataField: 'avg_30_days',
      text: 'Avg 30 days',
      sort: true,
      headerFormatter: headerFormatter
    },
    {
      dataField: 'total_assignment',
      text: 'Total Assgmnt.',
      sort: true,
      headerFormatter: headerFormatter
    },
    {
      dataField: 'allowance',
      text: 'Allowance',
      sort: true,
      headerFormatter: headerFormatter,
      formatter: allowanceFormatter
    },
    {
      dataField: 'bandwith_alerts',
      text: 'Bandwidth (Alerts)',
      headerFormatter: headerFormatter,
      sort: true,
      formatter: bandWithFormatter,
      sortFunc: sortBandwith
    }
  ];

  const pagination = paginationFactory({
    hideSizePerPage: true,
    sizePerPage: 5
  });

  if (data) {
    return (
      <BootstrapTable
        bootstrap4
        striped
        keyField="name"
        data={data}
        columns={columns}
        defaultSorted={defaultSorted}
        pagination={pagination}
      />
    );
  }

  return null;
};

AnalystDetailsTable.propTypes = {
  data: PropTypes.array
};

export default AnalystDetailsTable;
